'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/standard-empty.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _glamorous = require('glamorous');
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _standardBar = require('./base-components/standard-bar');
var _standardBar2 = _interopRequireDefault(_standardBar);
var _headerWrapper = require('./header-wrapper');
var _headerWrapper2 = _interopRequireDefault(_headerWrapper);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// A white bar able to take children

var Standard = function (_Component) {
  _inherits(Standard, _Component);
  function Standard() {
    _classCallCheck(this, Standard);
    return _possibleConstructorReturn(this, (Standard.__proto__ || Object.getPrototypeOf(Standard)).apply(this, arguments));
  }
  _createClass(Standard, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        theme = _props.theme,
        smallLogo = _props.smallLogo,
        link = _props.link,
        rest = _objectWithoutProperties(_props, ['theme', 'smallLogo', 'link']);
      return _react2.default.createElement(_headerWrapper2.default, Object.assign({
        marginBottom: theme.space_md,
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)'
      }, rest, {
        sections: [{
          key: 'main',
          render: function render() {
            return _react2.default.createElement(_standardBar2.default, {
              logoProps: {
                small: smallLogo,
                link: link
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 33
              },
              __self: _this2
            }, _this2.props.children);
          }
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        },
        __self: this
      }));
    }
  }]);
  return Standard;
}(_react.Component);
Standard.propTypes = {
  theme: _propTypes.object.isRequired,
  smallLogo: _propTypes.bool,
  link: _propTypes.string,
  children: _propTypes.node
};
Standard.defaultProps = {
  children: undefined,
  smallLogo: false
};
exports.default = (0, _glamorous.withTheme)(Standard);